import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminMileagesApi } from "../../http/mileages/api";
import { convertKilometersToMiles, formatDate } from "../../types/utils";
import HistoryDialog from "../ui/HistoryDialog";

import { useUserSettings } from "../../context/userSettingsContext";
import VersionDialog from "../ui/VersionDialog";

type MileageHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const MileageHistoryDialog: FC<MileageHistoryDialogProps> = ({
  onClose,
  itemToShowVersionsId,
  itemVersionToShowVersions,
}) => {
  const i18n = useI18n();
  const userSettings = useUserSettings();
  const mileagesApi = useAdminMileagesApi();

  return (
    <HistoryDialog
      title={i18n.t.mileages.versions}
      entityId={itemToShowVersionsId}
      lastVersion={itemVersionToShowVersions}
      getHistory={mileagesApi.getMileageHistory}
      getEntityVersionHook={mileagesApi.getMileageVersion}
      onClose={onClose}
      renderForm={(headers, data) => (
        <>
          <VersionDialog.Table headers={headers}>
            {(data?.current?.car?.id ?? null) !== (data?.next.car?.id ?? null) && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.cars.singular}
                  value={
                    data?.current
                      ? data?.current?.car?.currentPlateNumber || data?.current?.car?.vehicleIdentificationNumber
                      : undefined
                  }
                  edited={data?.next.car?.currentPlateNumber || data?.next.car?.vehicleIdentificationNumber}
                />
              </tr>
            )}

            {data?.current?.distance != data?.next.distance && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.mileage}
                  value={
                    data?.current
                      ? !!userSettings.me.distanceInMiles
                        ? `${convertKilometersToMiles(data?.current?.distance)} ${i18n.t.common.miles}`
                        : `${data.current.distance} km`
                      : undefined
                  }
                  edited={
                    !!userSettings.me.distanceInMiles
                      ? `${convertKilometersToMiles(data?.next.distance)} ${i18n.t.common.miles}`
                      : `${data.next.distance} km`
                  }
                />
              </tr>
            )}

            {data?.current?.date != data?.next.date && (
              <tr>
                <VersionDialog.Field
                  label={i18n.t.common.date}
                  value={data?.current ? formatDate(data?.current?.date, i18n.language) : undefined}
                  edited={formatDate(data?.next.date, i18n.language)}
                />
              </tr>
            )}
          </VersionDialog.Table>
        </>
      )}
    />
  );
};

export default MileageHistoryDialog;
